
export function PPO ({auth}) {

  return (
    <div>
    	<h1>Composant PPO</h1>
    	Ici c'est l'a PPO !
    </div>
  );
}